import styles from "./location-badge.module.css";

/**
 * **A location's code badge** (CF-D2): the code in letters, in the location's
 * hue on a soft tint of it. The letters carry the meaning and the hue only
 * helps scanning, so the badge reads the same to someone who cannot tell the
 * hues apart. The full name is the hover text and what a screen reader hears.
 */
export function LocationBadge({
  code,
  hue,
  name,
  size = "normal",
}: {
  code: string;
  hue: number;
  name: string;
  size?: "normal" | "small";
}): React.JSX.Element {
  return (
    <span
      className={size === "small" ? `${styles.badge} ${styles.small}` : styles.badge}
      style={{ "--h": `var(--c-loc-${String(hue % 10)})` } as React.CSSProperties}
      title={name}
      aria-label={name}
      data-testid="location-badge"
    >
      {code}
    </span>
  );
}
